import React from "react";
import { Box, Typography } from "@mui/material";

export default function Glossary() {
    return (
        <Box sx={{ px: 15, py: 8 }}>
            <Typography variant="h2" component="h2">
                Glossary
            </Typography>
            <Box sx={{ py: 3 }}>
                <Typography variant="body1" component="div">
                    Pipeline definition
                    <br /><br />
                    <strong>Major Public Infrastructure Pipeline (MPIP):</strong> Publicly funded infrastructure projects valued over $100 million in New South Wales, Victoria, Queensland and Western Australia, and over $50 million in South Australia, the Australian Capital Territory, the Northern Territory and Tasmania.
                    <br /><br />
                    <strong>Small Capital Public Infrastructure Pipeline (SCPIP):</strong> Publicly funded infrastructure projects valued $100 million and under in New South Wales, Victoria, Queensland and Western Australia, and $50 million and under in South Australia, the Australian Capital Territory, the Northern Territory and Tasmania.
                    <br /><br />
                    <strong>Private Infrastructure Pipeline:</strong> Privately funded public infrastructure such as a wind farm that is funded, delivered, and operated by the private sector.
                    <br /><br />
                    <strong>Private construction:</strong> Residential and non-residential buildings projects.
                    <br /><br />
                    <strong>Road maintenance:</strong> Resource demands for road maintenance projects.
                    <br /><br />
                    Project type definition 
                    <br />
                    <ul>
                        <li>
                            <strong>Buildings:</strong> non-residential buildings for health, education, sport, justice, transport buildings (e.g., parking facility and warehouse), other buildings (art facilities, civic/convention centres, and offices), limited coverage of detached and semi-detached residential buildings.
                        </li> <br></br>
                        <li>
                            <strong>Transport:</strong> roads, railways, level crossings and other transport projects such as airport runways.
                        </li><br></br>
                        <li>
                            <strong>Utilities:</strong> water and sewerage, energy and fuels, gas and water pipelines, and telecommunications.
                        </li>
                    </ul>
                </Typography>
            </Box>
        </Box>
    );
}
